export function AlbertaCTA() {
  const handleAssessment = () => {
    window.REACT_APP_NAVIGATE('/property-assessment');
  };

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const services = [
    'Complete licensing application management for Edmonton or Calgary',
    'Development permit coordination (Calgary)',
    'Fire safety inspection scheduling and compliance',
    'Insurance procurement and verification',
    'Guest registry and complaint management systems',
    'Tax collection and remittance (GST, Tourism Levy)',
    'Platform listing optimization and compliance',
    'Ongoing regulatory monitoring and updates',
    'Neighbor relations and complaint resolution',
    'Annual renewal management and documentation'
  ];

  return (
    <section id="contact" className="py-24 lg:py-32 bg-[#F0F0F0]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
          <div className="grid lg:grid-cols-2">
            <div className="p-12 lg:p-16">
              <h2 className="font-['Fraunces'] text-4xl lg:text-5xl font-bold text-[#505A5A] mb-6">
                Navigate Alberta STR regulations with confidence
              </h2>
              <p className="text-lg text-[#505A5A]/70 mb-8 leading-relaxed">
                Whether you're operating in Edmonton's flexible framework or Calgary's stricter system, we handle all compliance requirements so you can focus on hosting.
              </p>

              <div className="space-y-4 mb-10">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#882629]/10 rounded-xl flex-shrink-0">
                    <i className="ri-shield-check-line text-2xl text-[#882629]"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#505A5A] mb-2">Full Compliance Management</h3>
                    <p className="text-sm text-[#505A5A]/70">We handle all licensing, permits, inspections, and ongoing compliance requirements for both cities.</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#882629]/10 rounded-xl flex-shrink-0">
                    <i className="ri-map-pin-line text-2xl text-[#882629]"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#505A5A] mb-2">City-Specific Expertise</h3>
                    <p className="text-sm text-[#505A5A]/70">Deep knowledge of Edmonton and Calgary regulations, enforcement patterns, and best practices.</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#882629]/10 rounded-xl flex-shrink-0">
                    <i className="ri-money-dollar-circle-line text-2xl text-[#882629]"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#505A5A] mb-2">Maximize Your Revenue</h3>
                    <p className="text-sm text-[#505A5A]/70">Strategic guidance to optimize your rental within regulatory constraints and market conditions.</p>
                  </div>
                </div>
              </div>

              <button 
                onClick={handleAssessment}
                className="bg-[#882629] text-white px-8 py-4 rounded-full text-lg font-medium hover:bg-[#6E1F22] transition-all cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl w-full sm:w-auto"
              >
                Get started with Alberta compliance
              </button>
            </div>

            <div className="bg-[#F0F0F0] p-12 lg:p-16">
              <h3 className="text-2xl font-semibold text-[#505A5A] mb-8">
                Complete Alberta STR Services
              </h3>
              <ul className="space-y-4">
                {services.map((service, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-[#882629] text-xl flex-shrink-0 mt-0.5"></i>
                    <span className="text-[#505A5A] leading-relaxed">{service}</span>
                  </li>
                ))}
              </ul>

              <div className="mt-10 p-6 bg-white rounded-xl border-l-4 border-[#882629]">
                <p className="text-sm text-[#505A5A]/70 mb-4">
                  <strong className="text-[#505A5A]">Contact us:</strong>
                </p>
                <div className="space-y-2 text-sm text-[#505A5A]/70">
                  <p><i className="ri-mail-line text-[#882629] mr-2"></i>contact@furnishedrentalmanagement.com</p>
                  <p><i className="ri-phone-line text-[#882629] mr-2"></i>+1 (778) 386-9229</p>
                  <p><i className="ri-map-pin-line text-[#882629] mr-2"></i>Serving Edmonton, Calgary, and surrounding areas</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
